import {
    DEVICE,
    DEVICE_SUCCESS,
    DEVICE_ERROR,
    DEVICE_ID,
    DEVICE_ID_SUCCESS,
    DEVICE_ID_ERROR,
    ADD_DEVICE,
    ADD_DEVICE_SUCCESS,
    ADD_DEVICE_ERROR,
    UPDATE_DEVICE,
    UPDATE_DEVICE_SUCCESS,
    UPDATE_DEVICE_ERROR,
    CLEAR_DEVICES,
    DEVICE_SORT,
    DEVICE_SORT_ERROR,
    DEVICE_SORT_SUCCESS,
    DEVICE_RESIDENTS,
    DEVICE_RESIDENTS_ERROR,
    DEVICE_RESIDENTS_SUCCESS,
    DEVICE_LOCATIONS,
    DEVICE_LOCATIONS_ERROR,
    DEVICE_LOCATIONS_SUCCESS,
    DEVICE_SERIALS,
    DEVICE_SERIALS_ERROR,
    DEVICE_SERIALS_SUCCESS,
    ADD_MESSAGE,
    ADD_MESSAGE_SUCCESS,
    ADD_MESSAGE_ERROR,
    ADD_MESSAGE_FILTERS,
    ADD_MESSAGE_FILTERS_SUCCESS,
    ADD_MESSAGE_FILTERS_ERROR,
    DEVICE_ALL_SUCCESS,
    EXPORT_DEVICE,
    EXPORT_DEVICE_SUCCESS,
    EXPORT_DEVICE_ERROR,
    DEVICE_DOCSIS,
    DEVICE_DOCSIS_ERROR,
    DEVICE_DOCSIS_SUCCESS
} from "../constants/devicesConstants";

const initialState = {
    loading: false,
    success: false,
    error: '',
    residents: [],
    locations: [],
    serials: [],
    docsis:[],
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};

function deviceReducer(state = initialState, action) {
    switch (action.type) {
        case DEVICE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'THE DEVICES ARE BEING LOADED',
                'type': action.type
            });
        case DEVICE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DEVICE_SUCCESS:
            if (state.deviceData) {
                const oldDevices = state.deviceData.filter(device => !action.data.data.some(dev => dev._id === device._id));
                action.data.data = oldDevices.concat(action.data.data);
            }
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'deviceData': action.data.data,
                'totalDevices': action.data.totalDevices,
                'type': action.type
            });
        case DEVICE_ALL_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'deviceData': action.data.data,
                'totalDevices': action.data.totalDevices,
                'type': action.type
            });
        case DEVICE_SORT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'THE DEVICES ARE BEING LOADED',
                'type': action.type
            });
        case DEVICE_SORT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DEVICE_SORT_SUCCESS:
            if (state.deviceData && action.page !== 0) {
                const oldDevices = state.deviceData.filter(device => !action.data.data.some(dev => dev._id === device._id));
                action.data.data = oldDevices.concat(action.data.data);
            }
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'deviceData': action.data.data,
                'totalDevices': action.data.totalDevices,
                'type': action.type
            });
        case DEVICE_RESIDENTS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'THE RESIDENTS NAMES ARE BEING LOADED',
                'type': action.type
            });
        case DEVICE_RESIDENTS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DEVICE_RESIDENTS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'residents': action.data,
                'type': action.type
            });
        case DEVICE_LOCATIONS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'THE LOCATIONS ARE BEING LOADED',
                'type': action.type
            });
        case DEVICE_LOCATIONS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DEVICE_LOCATIONS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'locations': action.data,
                'type': action.type
            });
        case DEVICE_SERIALS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'THE DEVICE SERIAL NUMBERS ARE BEING LOADED',
                'type': action.type
            });
        case DEVICE_SERIALS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DEVICE_SERIALS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'serials': action.data,
                'type': action.type
            });
        case DEVICE_DOCSIS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'THE DEVICES DOCSIS MAC ARE BEING LOADED',
                'type': action.type
            });
        case DEVICE_DOCSIS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DEVICE_DOCSIS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'docsis': action.data,
                'type': action.type
            });
        case DEVICE_ID:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'THE DEVICE IS BEING LOADED',
                'type': action.type
            });
        case DEVICE_ID_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DEVICE_ID_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type
            });
        case ADD_DEVICE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'THE DEVICE IS BEING SAVED',
                'type': action.type
            });
        case ADD_DEVICE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_DEVICE_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'deviceData': [...state.deviceData, action.data],
                'totalDevices': state.deviceData.lenght,
                'type': action.type
            });
        case UPDATE_DEVICE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'THE DEVICE IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_DEVICE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_DEVICE_SUCCESS:
            const oldDeviceData = state.deviceData ? state.deviceData : []
            let newDeviceData
            if (Array.isArray(oldDeviceData) && oldDeviceData.lenght > 0) {
                newDeviceData = oldDeviceData.map(device => { if (device._id === action.data._id) { return action.data } else { return device } })
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'deviceData': newDeviceData,
                'type': action.type
            });
        case CLEAR_DEVICES:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'deviceData': [],
                'totalDevices': 0,
                'type': action.type
            });
        case ADD_MESSAGE:
        case ADD_MESSAGE_FILTERS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'SENDING MESSAGE...',
                'type': action.type
            });
        case ADD_MESSAGE_ERROR:
        case ADD_MESSAGE_FILTERS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_MESSAGE_SUCCESS:
        case ADD_MESSAGE_FILTERS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type
            });

        case EXPORT_DEVICE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'loadingTitle': 'DEVICE',
                'loadingMessage': 'EXPORTING INFORMATION...',
                'type': action.type
            });
        case EXPORT_DEVICE_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type
            });
        case EXPORT_DEVICE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': '',
                'type': action.type
            });
        default:
            return state;
    }
}

export default deviceReducer;

